/** Overlay de carga con el logotipo (sustituye `.loading-consalud`). */
export function PantallaCarga({ texto = 'Cargando…' }: { texto?: string }) {
  return (
    <div className="grid min-h-dvh place-items-center" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-5">
        <img
          src="/img/isotipo-cerebro-blanco.png"
          alt=""
          className="solo-oscuro h-16 animate-pulse"
        />
        <img src="/img/isotipo-cerebro-azul.png" alt="" className="solo-claro h-16 animate-pulse" />
        <div className="h-1 w-40 overflow-hidden rounded-full bg-[var(--pista)]">
          <div className="h-full w-1/2 animate-[cargando_1.1s_ease-in-out_infinite] rounded-full bg-cian-500" />
        </div>
        <p className="text-sm text-texto-2">{texto}</p>
      </div>
      <style>
        {'@keyframes cargando{0%{transform:translateX(-100%)}100%{transform:translateX(200%)}}'}
      </style>
    </div>
  );
}
